import React, {useEffect, useState} from 'react'
import { inputTypes, formatTypes} from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './BatasUpahHarian.service'
import Utils from '../../../libs/custom/Utils'

const BatasUpahHarianForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [isEdit, setIsEdit] = useState(false)

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      setIsEdit(true)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      noValidate
      customRules={{
        dari: 'required|size:4',
        ke: 'required|size:4',
        lapis1: 'required|numeric',
        lapis2: 'required|numeric',
        lapis3: 'required|numeric',
      }}
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/batas-upah-harian`}
      baseId="mod-form-sample"
      title={t.translate('modules.batasUpahHarian.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT_MASK,
          label: 'Mulai Berlaku (Tahun)',
          key: 'dari',
          width: '49%',
          style: {marginRight: '2%'},
          // required: true,
          disabled: isEdit,
          mask: '****',
          alwaysShowMask: true,
          allowNegative: false
        },{
          inputType: inputTypes.INPUT_MASK,
          label: 'Sampai Berlaku (Tahun)',
          key: 'ke',
          width: '49%',
          // required: true,
          disabled: isEdit,
          mask: '****',
          alwaysShowMask: true,
          allowNegative: false
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Lapis 1 (Rp)',
          key: 'lapis1',
          // required: true,
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Lapis 2 (Rp)',
          key: 'lapis2',
          // required: true,
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Lapis 3 (Rp)',
          key: 'lapis3',
          // required: true,
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          data = Utils.formNormalize(data)
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/batas-upah-harian')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(BatasUpahHarianForm))
